import React from 'react'

import Content from 'components/base/Content'
import Title from 'components/base/Title'
import Paragraph, { Theme as ParagraphTheme } from 'components/base/Paragraph'

import QuotingWrapper, { Theme as QuotingWrapperTheme } from 'components/blocks/QuotingWrapper'

const SuggestInsuranceSuccessScreen: React.FC = (): React.ReactElement => (
  <QuotingWrapper noPadding={true} theme={QuotingWrapperTheme.concierge} title='Nice!'>
    <Title level={3}>Thanks!</Title>
    <Content margined={true} center={true} short={true} minheight={true}>
      <Paragraph theme={ParagraphTheme.intro}>
        {`We'll be in touch when we launch the product you're seeking in your
                area. We appreciate your suggestions.`}
      </Paragraph>
    </Content>
  </QuotingWrapper>
)

export default SuggestInsuranceSuccessScreen
